import { Box, BoxProps, HStack, Text } from '@chakra-ui/react';
import { useCheckoutConfigContext } from '@contexts/CheckoutConfig';
import { useModal, withModal } from '@contexts/Modal';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { When } from 'react-if';

const Footer: FC<BoxProps> = (props) => {
  const { checkout } = useCheckoutConfigContext();
  const { t } = useTranslation();

  const { openModal } = useModal();

  const handleTos = () => {
    openModal({
      title: t('Terms and conditions'),
      body: (
        <Box maxH="400px" overflowY="auto">
          <Text size="sm" dangerouslySetInnerHTML={{ __html: checkout.organization.tos || '' }} />
        </Box>
      ),
      closeable: true,
      modalProps: { size: 'xl' },
    });
  };

  const handleOpenPolicy = () => {
    openModal({
      title: t('Privacy policy'),
      body: (
        <Box maxH="400px" overflowY="auto">
          <Text
            size="sm"
            dangerouslySetInnerHTML={{ __html: checkout.organization.privacy_policy || '' }}
          />
        </Box>
      ),
      closeable: true,
      modalProps: { size: 'xl' },
    });
  };

  return (
    <Box mt={16} mb={4} position="absolute" bottom={0} {...props}>
      <HStack spacing={4}>
        <When condition={checkout.organization.tos}>
          <Text
            _hover={{ textDecor: 'underline' }}
            color="gray.400"
            cursor="pointer"
            onClick={handleTos}
          >
            {t('Terms and conditions')}
          </Text>
        </When>

        <When condition={checkout.organization.privacy_policy}>
          <Text
            _hover={{ textDecor: 'underline' }}
            color="gray.400"
            cursor="pointer"
            onClick={handleOpenPolicy}
          >
            {t('Privacy Policy')}
          </Text>
        </When>
      </HStack>
    </Box>
  );
};

export default withModal(Footer) as FC<BoxProps>;
